export const TRN_MATCH_BIOSEC_VALUES = 'TRN_MATCH_BIOSEC_VALUES'
export const TRN_MATCH_BIOSEC_VALUES_REMOVE = 'TRN_MATCH_BIOSEC_VALUES_REMOVE'
export const TRN_MATCH_BIOSEC_VALUES_CLEANUP = 'TRN_MATCH_BIOSEC_VALUES_CLEANUP'

export const matchBiosecurityValues = (payload) => ({
  payload,
  type: TRN_MATCH_BIOSEC_VALUES,
})

export const matchBiosecurityValuesRemove = (...payload) => ({
  payload,
  type: TRN_MATCH_BIOSEC_VALUES_REMOVE,
})

export const matchBiosecurityValuesCleanUp = () => ({
  payload: null,
  type: TRN_MATCH_BIOSEC_VALUES_CLEANUP,
})
